interface ScoringToolProps {
  toolName: string;
  args: any;
  result?: string;
  status?: "running" | "complete" | "error";
}

export function ScoringTool({
  toolName: _toolName,
  args,
  result,
  status,
}: ScoringToolProps) {
  // Parse the result if available
  let parsedResult: any = null;
  if (result) {
    try {
      parsedResult = JSON.parse(result);
    } catch (e) {
      console.warn("Failed to parse scoring result:", result);
    }
  }

  return (
    <div>
      {/* Show parameters as simple text */}
      {args && Object.keys(args).length > 0 && (
        <div className="space-y-1 text-sm text-gray-500">
          {Object.entries(args).map(([key, value]) => (
            <div key={key}>
              {key.replace(/_/g, " ")}: {String(value)}
            </div>
          ))}
        </div>
      )}

      {/* Show structured results when complete */}
      {parsedResult && status === "complete" && (
        <div className="mt-3">
          <div className="rounded-lg bg-gray-50 p-3">
            <div className="mb-1 font-medium text-gray-900">Mentor Scoring</div>
            <div className="text-sm text-gray-600">
              Scoring data processed successfully
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
